import { BranchingError } from "~/branching/model/branching-error";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

/**
 * Map SDK/HTTP errors to a typed `BranchingError` for the domain port.
 */
export function toBranchingError(cause: unknown): BranchingError {
  if (cause instanceof BranchingError) {
    return cause;
  }
  if (isRecord(cause) && "response" in cause) {
    const res = (cause as { response?: { status?: number } }).response;
    if (res && typeof res.status === "number") {
      if (res.status === 404) {
        return new BranchingError("not-found", "Resource not found", cause);
      }
      if (res.status === 409) {
        return new BranchingError("conflict", "Request conflict", cause);
      }
      if (res.status === 0 || res.status >= 500) {
        return new BranchingError("unavailable", "Service unavailable", cause);
      }
    }
  }
  if (cause instanceof Error) {
    return new BranchingError("unknown", cause.message, cause);
  }
  return new BranchingError("unknown", "Unknown error", cause);
}
